module.exports = __webpack_public_path__ + "static/ericson-nikola-tesla-bw-fb7db131ae612b7d4ed9a1ebf5b7e6f5.jpg";